<template>
  <div
    ref="signageFrame"
    class="site"
    :class="{ debug: debug }"
    :style="{
      top: marginVertical + 'px ',
      bottom: marginVertical + 'px ',
      left: +marginHorizontal + 'px',
      right: +marginHorizontal + 'px'
    }"
    data-test-id="signage-site"
    @click="$router.push('/')"
  >
    <warning-message
      v-if="!site.loaded"
      is-loading-message
    >
      {{ $t('status.loading') }}
    </warning-message>
    <div v-else-if="site">
      <warning-message
        v-if="moviesFiltered.length == 0"
      >
        {{ $t('showing.noShowingsToday') }}
      </warning-message>

      <!-- We have a showtimes-->
      <div class="main-display">
        <div
          v-if="pageMode"
          class="page-number"
        >
          {{ pageNumberText }}
        </div>
        <div>
          <img
            class="site-logo"
            :src="site.lightLogoImageUrl"
          >
          <div class="time text-uppercase">
            {{ site.siteTime.format("h:mm a") }}
          </div>
        </div>
        <div class="movie-grid">
          <div
            v-for="(showings, index) in currentMovies"
            :key="index"
            class="movie-container"
          >
            <div
              v-if="showings[0]"
              class="movie"
            >
              <div id="posterWrapper">
                <div
                  class="poster"
                  :class="{ cover: cover }"
                  :style="{
                    backgroundImage: `url(${showings[0].movie.posterImageUrlNoParams}?fit=fill&fill=solid&fill-color=${index % 2 == 0 ? '191919' : '101010'}&w=${($refs.signageFrame.clientWidth / currentMovies.length).toFixed()}&h=${($refs.signageFrame.clientHeight * (posterHeightInt / 100)).toFixed()})`,
                    height: `${posterHeight}`
                  }"
                />
              </div>
              <div
                class="movie-name row justify-center items-center q-py-sm text-center"
                :style="`${isComponent ? 'font-size: 1.3vw; margin-bottom: 50%' : 'font-size: 3vh;'}`"
              >
                {{ showings[0].movie.name }}
              </div>
              <div
                v-if="site.signageConfig.display_rating"
                class="row justify-center items-center column q-my-sm"
                style="width: 100%"
              >
                <rated
                  v-if="showings[0].movie.rating"
                  :rated="showings[0].movie.rating"
                  :rating-reason="showings[0].movie.ratingReason"
                  :outline="false"
                  :color="'white'"
                  :text-color="'dark'"
                  :font-size="24"
                  :highlight-r-rated="highlightRRated"
                  :disable-official-symbol="disableOfficialSymbol"
                  class="text-bold q-px-sm"
                />
                <div
                  v-if="showings[0].movie.ratingReason && showings[0].movie.ratingReason.length"
                  style="width: 100%; position: relative; height: 3vh; font-size: 2vh;"
                >
                  <div style="position: absolute; top: 0; left: 10%; width: 80%; height: 100%; overflow-x: hidden;">
                    <div
                      class="spinning"
                    >
                      <span class="spinning-text">
                        {{ showings[0].movie.ratingReason }}
                      </span>
                      <span class="spinning-text">
                        {{ showings[0].movie.ratingReason }}
                      </span>
                      <span class="spinning-text">
                        {{ showings[0].movie.ratingReason }}
                      </span>
                      <span class="spinning-text">
                        {{ showings[0].movie.ratingReason }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <q-carousel
              v-if="showings[0] && compactShowingTimes"
              :key="showings[0].movie.id"
              v-model="showings[0].movie.slide"
              vertical
              transition-prev="slide-down"
              transition-next="slide-up"
              :infinite="showings.length > compactShowingLength"
              control-color="white"
              navigation-icon="radio_button_unchecked"
              arrows
              :prev-icon="showings[0].movie.slide !== 0 ? 'expand_less' : 'none'"
              :next-icon="showings[0].movie.slide + 1 < showings.length / compactShowingLength ? 'expand_more' : 'none'"
              animated
              padding
              :autoplay="5000"
              class="showings"
              style="background-color: inherit;"
            >
              <q-carousel-slide
                v-for="(showingsConcat, i) in $_.chunk(showings, compactShowingLength)"
                :key="showingsConcat[0].id"
                :name="i"
                class="column no-wrap"
              >
                <div
                  v-for="showing in showingsConcat"
                  :key="showing.id"
                  class="showing text-uppercase row column"
                  :style="{
                    color: color(showing),
                    'line-height': `${lineHeight(showingsConcat.length)}vw`,
                    'font-size': `${fontSize(showingsConcat.length)}vw`
                  }"
                  style="display: grid; width: 100%; padding: 0 0.5vw;"
                >
                  <div
                    class="row justify-between items-center self-center full-width overflow-hidden"
                  >
                    <span
                      class="showing-time col text-center"
                    >
                      {{ showing.siteTime.format("h:mm a") }}{{ showing.siteTime.format("h:mm a").length === 7 ? '&nbsp;&nbsp;' : '' }}
                    </span>
                    <showing-badges
                      v-if="displayShowingBadges"
                      :showing="showing"
                      :color="showing.current ? 'grey-4' : 'white'"
                      :current="showing.current"
                      :size="`${fontSize(showingsConcat.length)*0.6}vw`"
                      class="col"
                      :style="{ 'height': `${fontSize(showingsConcat.length)}vw` }"
                    />
                  </div>
                </div>
              </q-carousel-slide>
            </q-carousel>
            <div
              v-else-if="showings[0]"
              class="showings"
              :style="`${isComponent ? 'margin-top: 30%' : ''};${displayShowingBadges ? 'align-items: flex-start;' : ''}`"
            >
              <div
                v-for="showing in showings"
                :key="showing.id"
                class="showing text-uppercase column"
                :style="{
                  'color': color(showing),
                  'line-height': `${lineHeight(showings.length)}vw`,
                  'font-size': `${fontSize(showings.length)}vw`
                }"
                style="display: grid; width: 100%; padding: 0 0.5vw;"
              >
                <div
                  class="row justify-between items-center self-center full-width overflow-hidden"
                >
                  <div
                    style="align-self: center;"
                    class="showing-time col text-center"
                  >
                    {{ showing.siteTime.format("h:mm a") }}{{ showing.siteTime.format("h:mm a").length === 7 ? '&nbsp;' : '' }}
                  </div>
                  <showing-badges
                    v-if="displayShowingBadges"
                    :showing="showing"
                    :color="showing.current ? 'grey-4' : 'white'"
                    :current="showing.current"
                    :size="`${fontSize(showings.length)*0.6}vw`"
                    class="col"
                    :style="{ 'height': `${fontSize(showings.length)}vw` }"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="displayShowingBadgesLegend"
              class="row justify-around"
              style="width: 100%;"
            >
              <div
                v-for="allBadges in badgesForShowings(showings)"
                :key="allBadges.id"
              >
                <showing-badge
                  :showing-badge="allBadges"
                  color="white"
                  size="md"
                  class="text-bold q-pa-none q-pb-sm bg-transparent"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <warning-message
      v-else-if="errorOccurred"
    >
      A network error occurred
    </warning-message>
    <warning-message
      v-else
    >
      {{ `Unknown Site - ${$route.params.id}` }}
    </warning-message>
  </div>
</template>

<script>
import { region } from 'src/config'
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'
import Rated from 'src/modules/consumer/components/Rated'
import ShowingBadges from 'src/modules/signage/components/ShowingBadges'
import WarningMessage from 'src/modules/signage/components/WarningMessage'
import ShowingsSignageConfigurationMixin from 'src/modules/signage/mixins/ShowingsSignageConfigurationMixin'
import { inject } from 'vue'

export default {
  name: 'Site2',
  components: {
    Rated,
    WarningMessage,
    ShowingBadges,
    ShowingBadge
  },
  mixins: [ShowingsSignageConfigurationMixin],
  models: {
    site: {
      fields: ['id', 'name', 'primaryColor', 'lightLogoImage', 'timeZone', 'signageConfig', 'migratedTo'],
      todaysShowings: {
        movie: 'default',
        screen: 'default',
        showingBadges: 'default'
      },
      variables () {
        return {
          id: this.siteId
        }
      },
      immediate: false,
      watchQuery: false
    }
  },
  props: {
    isComponent: {
      type: Boolean,
      required: false,
      default: false
    },
    siteId: {
      type: Number,
      required: false,
      default () {
        const route = inject('route')
        return route?.params?.siteId
      }
    },
    cover: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query?.cover === 'true' || false
      }
    },
    pageMode: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query?.mode === 'page'
      }
    },
    cycleMode: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query?.mode === 'cycle'
      }
    },
    moviesPerPage: {
      type: Number,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && parseInt(route.query['movies-per-page'])) || 7
      }
    },
    useBlankSlots: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && route.query['blank-slots'] === 'true') || false
      }
    },
    fixedPageNumber: {
      type: Number,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && parseInt(route.query['fixed-page-number'])) || 0
      }
    },
    interval: {
      type: Number,
      required: false,
      default () {
        const route = inject('route')
        return parseInt(route?.query?.interval) || 5000
      }
    },
    compactShowingTimes: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && route.query['compact-showing-times'] === 'true') || false
      }
    },
    compactShowingLength: {
      type: Number,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && parseInt(route.query['compact-showing-length'])) || 6
      }
    },
    compactShowingInterval: {
      type: Number,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && parseInt(route.query['compact-showing-interval'])) || 5000
      }
    },
    showtimeFontMultiplier: {
      type: Number,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && parseInt(route.query['showtime-font-multiplier'])) || 100
      }
    },
    displayShowingBadges: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && route.query['display-showing-badges'] === 'true') || false
      }
    },
    displayShowingBadgesLegend: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && route.query['display-showing-badges-legend'] === 'true') || false
      }
    }
  },
  data () {
    return {
      errorOccurred: false,
      sliceStart: 0
    }
  },
  computed: {
    titleClassIds () {
      if (!this.$route.query['title-class-ids']) return

      return _.map(this.$route.query['title-class-ids'].split(','), parseInt)
    },
    hidePast () {
      return this.$route.query['hide-past'] === 'true'
    },
    moviesFiltered () {
      if (!this.site) return

      return _(this.site.todaysShowings.data)
        .filter(showing => !this.titleClassIds || _.includes(this.titleClassIds, showing.movie.titleClassId))
        .filter(showing => !this.hidePast || !showing.past)
        .groupBy('movie.id')
        .sortBy(showings => -showings.length) // Second priority is number of showings
        .sortBy(showings => showings[0].screen.displayOrder) // First priority is what screen it is in
        .value()
    },
    maxShowings () {
      if (!this.site || !this.site.todaysShowings) return 0

      return _(this.moviesFiltered).values().map('length').max()
    },
    pageNumberText () {
      return `Page ${(this.sliceStart + this.moviesPerPage) / this.moviesPerPage} of ${Math.round((this.moviesFiltered.length / this.moviesPerPage) + 0.49)}`
    },
    posterHeightInt () {
      let height = this.site.signageConfig.display_rating ? 35 : 40
      if (this.isComponent) {
        height = 100
      }

      return height
    },
    posterHeight () {
      const height = this.posterHeightInt
      const suffix = this.isComponent ? '%' : 'vh'

      return height + suffix
    },
    currentMovies () {
      if (_.isEmpty(this.moviesFiltered)) {
        // If blank slots enabled in page mode, return array of nulls
        if (this.useBlankSlots && this.pageMode) {
          return Array(this.moviesPerPage).fill([null])
        }
        return []
      }

      // If not in page/cycle mode or movies fit on one page, return all movies
      if (this.moviesFiltered.length <= this.moviesPerPage || (!this.cycleMode && !this.pageMode)) {
        return this.moviesFiltered
      }

      // Calculate the slice
      const endIndex = Math.min(this.sliceStart + this.moviesPerPage, this.moviesFiltered.length)
      let movies = this.moviesFiltered.slice(this.sliceStart, endIndex)

      // Handle blank slots in page mode
      if (this.useBlankSlots && this.pageMode && movies.length < this.moviesPerPage) {
        const blankSlotsNeeded = this.moviesPerPage - movies.length
        for (let i = 0; i < blankSlotsNeeded; ++i) {
          movies.push([null])
        }
      }

      // Handle cycle mode - append items from the beginning to fill the page
      if (this.cycleMode && movies.length < this.moviesPerPage) {
        movies = [...movies, ...this.moviesFiltered.slice(0, this.moviesPerPage - movies.length)]
      }

      return movies
    }
  },
  async mounted () {
    this.moviesIntervalId = setInterval(async () => {
      await this.site.fetch(true)

      if (this.moviesFiltered.length > this.moviesPerPage && _.isNil(this.movieContentTimeout)) {
        this.setupMovieContent()
      } else if (!_.isNil(this.movieContentTimeout)) {
        clearTimeout(this.movieContentTimeout)
        this.movieContentTimeout = null
      }
    }, 10 * 60 * 1000)

    await this.site.fetch()

    if (this.site.migratedTo && this.site.migratedTo !== region) {
      let newUrl = ''
      if (region === 'us' && !window.location.href.includes('-us.')) {
        newUrl = window.location.href.replace('.indy.systems', `${this.site.migratedTo}.indy.systems`)
      } else {
        newUrl = window.location.href.replace(region, this.site.migratedTo)
      }

      if (newUrl !== window.location.href) {
        window.location = newUrl
      }
    }

    this.setupMovieContent()

    if (this.$signage) {
      // Fetching the site when in the app mode of digital-signage, sets the site_id cookie
      // This will reload the configuration data after being authenticated
      this.$handleAuthChange()
    }
  },
  beforeUnmount () {
    if (this.timeIntervalId) clearInterval(this.timeIntervalId)

    if (this.moviesIntervalId) clearInterval(this.moviesIntervalId)

    if (this.movieContentTimeout) clearTimeout(this.movieContentTimeout)
  },
  methods: {
    showingFontSize (original) {
      let multiplier = (this.showtimeFontMultiplier / 100.0) * original
      if (this.displayShowingBadges) {
        multiplier = multiplier * 0.8
      }
      return multiplier
    },
    lineHeight (length) {
      return this.showingFontSize(2.5 / ((length > 6 ? length : 6) / 6))
    },
    fontSize (length) {
      return this.showingFontSize(3.0 / ((length > 6 ? length : 6) / 6))
    },
    color (showing) {
      if (showing.current) {
        return this.$lightenColor(this.site.primaryColor, 80)
      } else if (showing.past) {
        return this.$lightenColor(this.site.primaryColor, 20)
      } else {
        return this.$lightenColor(this.site.primaryColor, 40)
      }
    },
    badgesForShowings (showings) {
      const allShowingBadges = _.uniq(_.flatten(_.map(showings, showing => showing.showingBadges.data)))
      return _.filter(allShowingBadges, badge => badge?.displayOnSignage)
    },
    getIntervalRounded () {
      const date = new Date()
      if (this.interval < 1000) {
        return this.interval
      } else {
        date.setSeconds(date.getSeconds() - (date.getSeconds() % (this.interval / 1000)) + this.interval / 1000)
      }

      return date - new Date()
    },
    updatePage () {
      const incrementCount = this.cycleMode ? 1 : this.moviesPerPage

      if (this.moviesFiltered.length > this.moviesPerPage) {
        this.sliceStart += incrementCount
        if (this.pageMode && this.fixedPageNumber) {
          this.sliceStart = (this.fixedPageNumber * this.moviesPerPage) - this.moviesPerPage
        } else if (this.sliceStart >= this.moviesFiltered.length) {
          this.sliceStart = 0
        }
      }
    },
    setupMovieContent () {
      if (this.moviesFiltered.length > this.moviesPerPage && (this.cycleMode || this.pageMode)) {
        if (this.pageMode && this.fixedPageNumber) {
          this.sliceStart = (this.fixedPageNumber * this.moviesPerPage) - this.moviesPerPage
        }

        const updateShowings = () => {
          this.movieContentTimeout = setTimeout(() => {
            this.updatePage()
            updateShowings()
          }, this.getIntervalRounded())
        }

        updateShowings()
      }
    }
  }
}
</script>

<style scoped>

.showing-time {
  flex-grow:1;
  flex-shrink:0;
  flex-basis:auto;
}

.site {
  background-color: #161616;
  color: #fff;
  position: absolute;
}

.site.debug {
  border: solid 1px red;
}

.rating {
  height: 3vh;
  display: inline-block
}

.main-display {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  flex-direction: column;
}

.site-logo {
  max-width: 50vw;
  max-height: 10vh;
}

.page-number {
  position: absolute;
  top: 2vh;
  left: 2vh;
  font-size: 3vh;
}

.time {
  position: absolute;
  top: 2vh;
  right: 2vh;
  font-size: 5vh;
}

.movie-grid {
  flex-grow: 1;
  overflow: hidden;

  display: flex;
}
.movie-container {
  flex-grow: 1;
  flex-basis: 0;

  display: flex;
  flex-direction: column;
  align-content: center;
}
.movie-container:nth-child(even) {
  background-color: #101010;
}
.movie-container:nth-child(odd) {
  background-color: #191919;
}
.debug .movie-container > div {
  border: solid 1px red;
}

.poster {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.poster.cover {
  background-size: cover;
}
.movie-name {

  text-overflow: ellipsis;

  overflow: hidden;
  text-overflow: ellipsis;

  max-height: 3em;
  height: 3em;
}

.showings {
  flex: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.showing {

  font-weight: 800;

  display: flex;
  flex-direction: column;
  justify-content: center;

  min-width: 0;
  flex-basis: 0;
}
.debug .showing {
  border: solid 1px yellow;
}
.past {
  color: #333;
}
.current {
  color: #1e57ff;
}
.spinning {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: -moz-fit-content;
  height: fit-content;

  min-width: 100%;
  animation: scroll-x 10s linear infinite;
}

.spinning-text {
  white-space: nowrap;
  width: fit-content;
}
.spinning-text:after {
  content: '\A';
  width:10px;
  height:10px;
  border-radius:50%;
  background: white;
  display:inline-block;
  margin:0 20px;
}

@keyframes scroll-x {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(calc(-100% - 0px));
  }
}
</style>
